import { Box } from '@byecode/ui'
import styled from 'styled-components'

export const EventWrapper = styled(Box)``
